export default {"src":"/_next/static/media/down_filled.6099f4c4.svg","height":24,"width":24};